import { Controller } from "@hotwired/stimulus"

// Simplified: allow normal navigation so server-rendered HTML (with pagination & counts) is always consistent.
// Keeping controller minimal in case future enhancements are desired.
export default class extends Controller {
  connect() {
    // No-op: default link behavior performs full page load.
  }
}
